import { KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight } from '@mui/icons-material';
import { Button, ButtonOwnProps, Link, Typography } from '@mui/material';
import React from 'react';

interface Props {
  children?: React.ReactElement<unknown>;
  href: string
  label: string
  isLeft?: boolean
  button?: ButtonOwnProps
}

export default function ArrowButton(props: Props) {
  return (
    <Link href={props.href}>
      <Button
        {...props.button}
        sx={(theme) => ({
          padding: '0.75rem 1.5rem',
          ".icon": {
            transition: '0.3s',
          },
          ".label": {
            fontWeight: 'bold',
            position: 'relative',
            '&.active': {
              '&::after': {
                transform: 'scale(1, 1)'
              }
            },
            '&:after': {
              position: 'absolute',
              left: 0,
              content: `''`,
              width: '100%',
              height: 3,
              background: theme.palette.grey[50],
              bottom: -1,
              transform: 'scale(0, 1)',
              transformOrigin: 'left top',
              transition: 'transform 0.3s'
            }
          },
          "&:hover .icon": {
            transition: '0.3s',
            transform: `translateX(${props.isLeft ? '-0.25rem' : '0.25rem'})`,
          },
          '&:hover .label': {
            '&::after': {
              transform: 'scale(1, 1)'
            }
          }
        })}
        color='secondary'
        variant="contained"
        endIcon={
          props.isLeft ?
            <KeyboardDoubleArrowLeft className="icon" />
            :
            <KeyboardDoubleArrowRight className="icon" />
        }
      >
        <Typography className="label">
          {props.label}
        </Typography>
      </Button>
    </Link>
  )
}